import { Dictionary } from './dictionary';

export const huDictionary: Dictionary = {
  hu: {
    title: 'MEKH Tájékoztatási Adatbázis',
    reports: 'Riportok',
    no_report_found: 'Nem található riport',
    navigate_to_reports: 'Riportok oldalra navigálás',
    contact: 'Kapcsolat:',
    mekh_logo_aria_label: 'MEKH logó. A logóra kattintva a MEKH weboldalra fog navigálni.',
    mekh_ugyfelszolgalat_aria_label: 'Ide kattintva felveheti a kapcsolatot az ügyfélszolgálattal.',
    only_public: 'Csak publikus adatok megjelenítése',
    all_public: 'Összes adat megjelenítése',
    unit_of_measeure: 'Mértékegység',
    year: 'Év',
    month: 'Hónap',
    day: 'Nap',
    halfYear: 'Félév',
    HY1: 'Első félév',
    HY2: 'Második félév',
    quarter: 'Negyedév',
    tetelek: 'Tételek',
    orszag: 'Ország',
    termekek: 'Termék',
    tevekenyseg: 'Tevékenység',
    keszletek: 'Készlettípus',
    engedelyes: 'Engedélyes',
    adat_tipus: 'Adat típus',
    regiok_es_varmegyek: 'Régiók és vármegyék',
    felhasznalasi_cel: 'Felhasználási cél',
    ertek: 'Érték',
    ezer_kobmeter: 'Ezer m3',
    ezer_tonna: 'Ezer tonna',
    kilo_tonna: 'kt',
    gigawatt_ora: 'GWh',
    ezer_forint: 'Ezer forint',
    forint: 'Ft',
    szazalek: 'Százalék',
    terajoule_netto: 'TJ (NCV)',
    terajoule_brutto: 'TJ (GCV)',
    huf_gigajoule_netto: 'Ft/GJ (NCV)',
    huf_gigajoule_brutto: 'Ft/GJ (GCV)',
    huf_kilowatt_ora: 'Ft/kWh',
    fogyasztasi_sav: 'Fogyasztási sáv',
    adozasi_szint: 'Adózási szint',
    help: 'Súgó',
    report_categories: 'Riport kategóriák',
    report_list: 'Riportok',
    treeitem_H1: 'Földgáz riportok',
    treeitem_H101: 'Földgáz szállítás',
    treeitem_H102: 'Földgáz tárolás',
    treeitem_H103: 'Földgáz kereskedelem',
    treeitem_H2: 'Villamosenergia riportok',
    treeitem_H201: 'VER adatok',
    treeitem_H202: '50MW és ezt meghaladó teljesítőképességű erőműve',
    treeitem_H203: 'Villamosenergia kereskedelem',
    treeitem_H204: 'Elektromos gépjárművek töltése',
    treeitem_S1: 'Évközi adatok',
    treeitem_S101: 'Szén és széntermékek',
    treeitem_S102: 'Kőolaj és kőolajtermékek',
    treeitem_S103: 'Földgáz',
    treeitem_S104: 'Villamos energia',
    treeitem_S105: 'Primer mérleg',
    treeitem_S106: 'Energia árak',
    treeitem_S107: 'S107',
    treeitem_S108: 'S108',
    treeitem_S109: 'S109',
    treeitem_S2: 'Éves adatok',
    treeitem_S201: 'Szén és széntermékek',
    treeitem_S202: 'Kőolaj és kőolajtermékek',
    treeitem_S203: 'Földgáz',
    treeitem_S204: 'Villamos energia',
    treeitem_S205: 'Hőenergia',
    treeitem_S206: 'Megújuló energia',
    treeitem_S207: 'Energiamérleg',
    treeitem_S208: 'Végső energia felhasználás',
    treeitem_S209: 'S209',
    chartType_bar: 'Oszlop',
    chartType_line: 'Vonal',
    chartType_area: 'Terület',
    chartType_fullstackedarea: '100%-ig halmozott terület',
    chartType_fullstackedbar: '100%-ig halmozott oszlop',
    chartType_fullstackedline: '100%-ig halmozott vonal',
    chartType_fullstackedspline: '100%-ig halmozott vonal II',
    chartType_fullstackedsplinearea: '100%-ig halmozott terület II',
    chartType_scatter: 'Pont',
    chartType_spline: 'Vonal II',
    chartType_splinearea: 'Terület II',
    chartType_stackedarea: 'Halmozott terület',
    chartType_stackedbar: 'Halmozott oszlop',
    chartType_stackedline: 'Halmozott vonal',
    chartType_stackedspline: 'Halmozott vonal II',
    chartType_stackedsplinearea: 'Halmozott terület II',
    chartType_steparea: 'Lépcsőzetes terület',
    chartType_stepline: 'Lépcsőzetes vonal',
    metaws_title: 'Összefoglaló adatok',
    metaws_dowload_date: 'Letöltés ideje:',
    metaws_publisher: 'Adatok közzétevője:',
    metaws_mekh: 'Magyar Energetikai- és Közmű-szabályozási Hivatal',
    metaws_source: 'Adatok forrása:',
    metaws_uom: 'Mértékegység:',
    metaws_lastupdate: 'Utolsó aktualizálás dátuma:',
    metaws_filters: 'Alkalmazott szűrők',
    metaws_seleted_all: 'Összes kiválasztva',
    metaws_year: 'Év'
  },
};
